<template>
<div id="payment-module">
  <h3>Platba</h3>
  <div v-for="paymentModule in paymentOptions">
    <!-- Payment by card online/Paypal -->
    <div class="form-row pfm-switch method-card-online" :class="{'selected': selectedMethod == paymentModule.option}" v-if="paymentModule.code == 'CARD_ONLINE'" @click="selectPaymentMethod(paymentModule)">
      <div class="payment-header header">
        <div class='radio-wrap'>
          <!-- <input type="radio" id="card-online" value="CARD_ONLINE" v-model="cart.payment.methodCode" v-on:change="formUpdated" /> -->
          <label for="card-online" class="radio-label">{{paymentModule.name[lang]}}</label>
          <span class="module-price">{{getPrice(paymentModule)}}</span>

        </div>
      </div>

      <div class="form-row-inner" v-if="selectedMethod == paymentModule.option">

        <!-- <braintree-hosted :authToken="authToken" :cart="cart" @btHFError='btHFError' v-if="authToken != null && gatewayMethod == 'BRAINTREE'" /> -->

        <stripe-elements :paymentOptions="paymentOptions" v-if="gatewayMethod == 'STRIPE'"/>

        <payu-redirect :paymentOptions="paymentOptions" v-if="gatewayMethod == 'PAYU'" />

        <payu-popup :paymentOptions="paymentOptions" v-if="gatewayMethod == 'PAYU-POPUP'" />

      </div>
    </div>
    <!-- By card at shop -->
    <div class="form-row pfm-switch" :class="{'selected': selectedMethod == 'CARD_SITE'}" v-if="paymentModule.code == 'CARD_SITE'" @click="selectPaymentMethod(paymentModule)">
      <div class="payment-header header">
        <div class='radio-wrap'>
          <!-- <input type="radio" id="card-pickup" value="CARD_SITE" v-model="selectedMethod" v-on:change="formUpdated" /> -->
          <label for="card-pickup" class="radio-label">{{paymentModule.name[lang]}}</label>
          <span class="module-price">{{getPrice(paymentModule)}}</span>
        </div>
      </div>
    </div>
    <!-- By cash at shop -->
    <div class="form-row pfm-switch" :class="{'selected': selectedMethod == 'CASH_SITE'}" v-if="paymentModule.code == 'CASH_SITE'" @click="selectPaymentMethod(paymentModule)">
      <div class="payment-header header">
        <div class='radio-wrap'>
          <!-- <input type="radio" id="cash-pickup" value="CASH_SITE" v-model="selectedMethod" v-on:change="formUpdated" /> -->
          <label for="cash-pickup" class="radio-label">{{paymentModule.name[lang]}}</label>
          <span class="module-price">{{getPrice(paymentModule)}}</span>
        </div>
      </div>
    </div>
    <!-- By Cash at delivery -->
    <div class="form-row pfm-switch" :class="{'selected': selectedMethod == 'CASH_DELIV'}" v-if="paymentModule.code == 'CASH_DELIV'" @click="selectPaymentMethod(paymentModule)">
      <div class="payment-header header">
        <div class='radio-wrap'>
          <!-- <input type="radio" id="cash-delivery" value="CASH_DELIV" v-model="selectedMethod" v-on:change="formUpdated" /> -->
          <label for="cash-delivery" class="radio-label">{{paymentModule.name[lang]}}</label>
          <span class="module-price">{{getPrice(paymentModule)}}</span>
        </div>
      </div>
    </div>
    <!-- Bank wire -->
    <div class="form-row pfm-switch" :class="{'selected': selectedMethod == 'BANK_WIRE'}" v-if="paymentModule.code == 'BANK_WIRE'" @click="selectPaymentMethod(paymentModule)">
      <div class="payment-header header">
        <div class='radio-wrap'>
          <!-- <input type="radio" id="bank-wire" value="BANK_WIRE" v-model="selectedMethod" v-on:change="formUpdated" /> -->
          <label for="bank-wire" class="radio-label">{{paymentModule.name[lang]}}</label>
          <span class="module-price">{{getPrice(paymentModule)}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Cart from '@/cart'
import Utils from '@/utils'

// import Dropin from './BrainTreeDropin.vue';
// import BraintreeHosted from '@/components/order/paymentMethods/BrainTreeHosted.vue'
import StripeElements from '@/components/order/paymentMethods/StripeElements.vue'
import PayuRedirect from '@/components/order/paymentMethods/PayURedirect'
import PayuPopup from '@/components/order/paymentMethods/PayUPopup'

import UserService from '@/service/user'
import Notification from '@/notification'

export default {
  props: ['cart', 'paymentOptions'],
  components: {
    // Dropin,
    // BraintreeHosted,
    StripeElements,
    PayuRedirect,
    PayuPopup
  },
  data() {
    return {
      lang: Cart.lang,
      authToken: null,
      gatewayMethod: null,
      paymentMethodWasSelectedAutomatically: false,
      txn: {
        billing: {
          firstName: '',
          lastName: '',
          streetAddress: '',
          extendedAddress: '',
          city: '',
          state: '',
          postalCode: ''
        },
        customer: {
          firstName: '',
          lastName: '',
          phone: '',
          email: ''
        },
        options: {
          submitForSettlement: true
        },
        payment: {
          amount: '',
          merchantAccountId: 'whildcaught',
          paymentMethodNonce: '',
          paymentMethodToken: '',
          paypal: ''
        }
      }
    }
  },
  computed: {
    selectedMethod() {
      return this.cart.payment.methodCode
    }
  },
  created() {
    // if there's only one payment option available, select it automatically
    if (this.paymentOptions.length == 1) {
      let paymentModule = this.paymentOptions[0]
      this.paymentMethodWasSelectedAutomatically = true
      this.selectPaymentMethod(paymentModule)
    } else if (this.cart.payment.methodCode && this.cart.payment.methodCode != '') {
      // Select the chosen method (if actually selected)
      let method = this.paymentOptions.filter(o => o.code == this.cart.payment.methodCode || o.option == this.cart.payment.methodCode)
      if (method) {
        console.log('Selecting chosen payment', method[0])
        this.selectPaymentMethod(method[0])
      }
    }

    // If the cart was updated, the form might have changed
    this.$parent.$parent.$off('updatedFromServer')
    this.$parent.$parent.$on('updatedFromServer', () => {
      this.formUpdated(false);
    });
  },
  methods: {
    getPrice(payment) {
      console.log('getPrice', payment)
      if (payment.price == null || payment.price == undefined) {
        return 'zdarma'
      }
      let price = parseInt(payment.price.brutto)
      if (price > 0) {
        return `${payment.price.brutto} Kč`
      } else {
        return 'zdarma'
      }
    },
    // btHFError(message) {
    //   this.$emit('paymentError', message) // bubble up
    // },
    formUpdated(reload) {
      console.log('Updated selection', this.cart.payment.methodCode, reload)
      // Request the Payment Auth Token
      // if (this.cart.payment.methodCode == 'CARD_ONLINE' && !this.authToken) {
      //   this.loadClientToken()
      // }
      // Set the payment price to the cart
      for (var i = 0; i < this.paymentOptions.length; i++) {
        if (this.paymentOptions[i].code == this.cart.payment.methodCode) {
          this.cart.payment.price = this.paymentOptions[i].price
          break;
        }
      }
      if (reload === undefined || reload) {
        this.$emit('updated');
      }
    },
    // loadClientToken() {
    //   console.log('getting auth token')
    //   // Notification.showWIP('...');
    //
    //   Cart.getPaymentAuthToken()
    //     .then(token => {
    //       this.authToken = token
    //       // Notification.hideWIP();
    //     })
    // },
    selectPaymentMethod(paymentModule) {
      // cons
      this.gatewayMethod = this.paymentOptions.filter(option => option.code == paymentModule.code && option.option == paymentModule.option)[0].option
      console.log('Selecting payment', paymentModule, this.gatewayMethod, this.paymentOptions.filter(option => option.code == paymentModule.code && option.option == paymentModule.option), paymentModule)
      this.cart.payment.methodCode = paymentModule.option ? paymentModule.option : paymentModule.code
      if (paymentModule.price) {
        this.cart.payment.price = paymentModule.price
      }
      this.formUpdated(true);
      // this method opens a 'window', so we scroll a bit
      if (paymentModule.code == 'CARD_ONLINE') {
        if (!this.paymentMethodWasSelectedAutomatically) {
          Utils.scrollTo({
            targetElementId: 'payment-module'
          })
        }
      }
      // this.$emit('updated')
    }
  },
}
</script>

<style lang='less'>
#payment-module {
  padding-top: 30px;

  .method-card-online {
    #loading-indicator {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 10px 0 10px 0;

      &.payment-module {
        padding-bottom: 40px;
      }

      .animation-wrap.loading {
        svg {
          width: 32px;
          height: 32px;
          animation: spin 1s linear infinite;

          * {
            fill: #ffffff;
          }
        }
      }
    }
  }
}
</style>
